import { CommonFunctions } from '../static/common-functions';
import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';
import { v_LocationDetailBus } from './v_LocationDetailBus';

export class DispatchKudosBus extends BaseBus
{
    constructor(data: DispatchKudosBus) {
        super(data);
    }
    CID(): any {
        return this.dispatchKudosId;
    }
    setId(id: any) {
        this.dispatchKudosId = id;
    }
    setParentId(id: any) {
        this.dispatchId = id;
    }
    initialize(data: DispatchKudosBus) {
    super.initialize(data);
    try {
      this.insertDt = CommonFunctions.getDate(data.insertDt);
      this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    catch {

    }

    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: v_LocationDetailBus = null) {
       // this.insertDt = date;
       // this.insertUserId = userId;
    }
    setFromForm(data: DispatchKudosBus) {
        super.setFromForm(data);
      }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!CommonFunctions.hasGuidValue(this.insertUser)) {
            this.insertDt = date;
            this.insertUser = userId;
        }
        this.updateDt = date;
        this.updateUser = userId;
    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    dispatchKudosId: any;
    personId: any;
    dispatchKudosCatId: any;
    comments: string;
    insertDt: Date;
    updateDt: Date;
    insertUser: any;
    updateUser: any;
    dispatchId: any;
    categoryName: string;
    personName: string;
    insertUserName: string;
}
